import { render, staticRenderFns } from "./serverDetailAlarmTab.vue?vue&type=template&id=5080f874&"
import script from "./serverDetailAlarmTab.vue?vue&type=script&lang=js&"
export * from "./serverDetailAlarmTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports